import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import {
  MoveFileToFinal,
  TriggerProdWorkFlow,
  TriggerProofWorkFlow,
} from "../../api/preworkDetailApi/preworkDetailApi";

interface MoveToFinalProps {
  isOpen: boolean;
  onClose: (isCancelClick: boolean, tabValue?: number) => void;
  title: string;
  selectedData: any;
  contextMenuType: number;
  tabValue?: number;
}

const MoveToFinal: React.FC<MoveToFinalProps> = ({
  isOpen,
  onClose,
  title,
  selectedData,
  contextMenuType,
  tabValue,
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    debugger;
    if (isOpen) {
      setLoading(false);
      console.log("Selected data::", title, contextMenuType);
    }
  }, [isOpen]);

  //Close the dialog box
  const handleCloseClick = () => {
    onClose(true);
  };

  const handleSendClick = async () => {
    try {
      setLoading(true);
      let response: any;
      //API call
      if (contextMenuType === 1) {
        response = await MoveFileToFinal(selectedData);
      } else if (contextMenuType === 2) {
        response = await TriggerProofWorkFlow(selectedData);
      } else if (contextMenuType === 3) {
        response = await TriggerProdWorkFlow(selectedData);
      }
      if (response) {
        onClose(false, tabValue);
      }
    } catch (error) {
      console.error("Error in MoveToFinal ", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleCloseClick}
        maxWidth="sm"
        PaperProps={{
          style: {
            height: "50.8%",
            width: "20%",
          },
        }}
      >
        <DialogTitle style={{ backgroundColor: "var(--primary-color)" }}>
          <div
            className="col-sm-12"
            style={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
            }}
          >
            <div
              className="col-sm-11"
              style={{
                display: "flex",
                alignItems: "left",
                gap: "10px",
                color: "var(--aggrid-text-color)",
              }}
            >
              {title}
            </div>
            <div
              className="col-sm-1"
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "right",
              }}
            >
              {" "}
              <Tooltip title="Close">
                <IconButton
                  onClick={() => onClose(true)}
                  style={{
                    cursor: "pointer",
                    alignItems: "flex-end",
                    color: "var(--aggrid-text-color)",
                    width: "20px",
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "60%",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <div className="row">
              <div className="col-sm-12" style={{ marginTop: "10px" }}>
                File Names
              </div>
              <div className="col-sm-12" style={{ marginTop: "-18px" }}>
                <List>
                  {selectedData.map((detail: any, i: number) => (
                    <ListItem key={detail.FileName}>
                      <ListItemIcon sx={{ minWidth: "20px" }}>
                        <FiberManualRecordIcon sx={{ fontSize: "8px" }} />
                      </ListItemIcon>
                      <ListItemText primary={detail.FileName} />
                    </ListItem>
                  ))}
                </List>
              </div>
              <div className="col-sm-12" style={{ marginTop: "8px" }}>
                <p>
                  Your selection contains {selectedData.length} number of files.
                  This move option involves zipping the files and then it will
                  move to the configured FTP/SFTP location.
                </p>
                <p> The larger the format, the longer it will take.</p>
                <p>
                  {" "}
                  Overall entire Move to Preflight of 50 MB files selection,
                  system will take 60 secs under general circumstances.
                </p>
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleSendClick}
            style={{ fontSize: "14px", height: "2.1em", padding: "4px 6px",border: "1px solid #144979", }}
          >
            Send
          </Button>
          <Button
            style={{ fontSize: "14px", height: "2.1em", padding: "4px 6px",border: "1px solid #144979", }}
            onClick={handleCloseClick}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MoveToFinal;
